import { motion } from 'framer-motion';

interface ProgressButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  variant?: 'cta' | 'ghost' | 'icon';
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'icon';
  className?: string;
}

function ProgressButton({
  children,
  onClick,
  variant = 'cta',
  size = 'md',
  className = '',
}: ProgressButtonProps) {
  const baseStyles =
    'inline-flex items-center justify-center font-medium rounded-xl transition-colors focus:outline-none disabled:opacity-50 cursor-pointer';

  const variants: Record<string, string> = {
    cta: 'text-white border border-purple-500/50',
    ghost: 'bg-transparent hover:bg-white/10 text-white/60 hover:text-white',
    icon: 'bg-transparent hover:bg-white/10 text-white/60 hover:text-white',
  };

  const sizes: Record<string, string> = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-base',
    lg: 'px-6 py-3 text-base',
    xl: 'px-8 py-4 text-lg',
    icon: 'w-10 h-10',
  };

  return (
    <motion.button
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      onClick={onClick}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
    >
      {children}
    </motion.button>
  );
}

export default ProgressButton;
